import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { SdsForm } from "soft_digi";
import { vehicles_get_all_select, vendors_get_all_select } from "../../services/site/SelectBoxServices";
import CustomerLedger from "./CustomerLedger";
import HubCapacity from "./HubCapacity";
import SalesDetailsTable from "./SalesDetailsTable";
import HubVsVichele from "./HubVsVichele";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";



const schema = Yup.object({});

const Index = () => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(schema),
  });

  const [type, setType] = useState<any>("");
  const [customers, setCustomers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  
  const formValues = watch();

  const categoryOptions = [
    { label: "Hub Capacity", value: "1" },
    { label: "Customer Ledger", value: "2" },
    { label: "Sales Report", value: "3" },
    { label: "Hub Wise Vehicle Report", value: "4" },
  ];

const yearOptions = Array.from({ length: 5 }, (_, i) => {
  const year = new Date().getFullYear() - 4 + i;
  return { label: String(year), value: String(year) };
});



  const monthOptions = Array.from({ length: 12 }, (_, i) => {
    const monthIndex = i;
    const date = new Date(0, monthIndex);
    const monthName = date.toLocaleString('default', { month: 'long' });
  
    return {
      value: (monthIndex + 1).toString().padStart(2, '0'),
      label: monthName,
    };
  });

  const selectedStage = watch("stage");

  useEffect(() => {
    vendors_get_all_select((data: any) => setCustomers(data));
    vehicles_get_all_select((data: any) => setVehicles(data));
  }, []);

  const onSubmit = (data: any) => {
    const stage = data.stage?.value || "";
    setType(stage);
  };

  const reportForm = () => {
    const formElements: SdsFormElementProps[] = [
      {
        type: "SELECT_BOX",
        width: 3,
        name: "stage",
        element: {
          label: "Select",
          options: categoryOptions,
          inputProps: { isFocussed: true },
          inputType: "BORDER_LABEL",
        },
      },
      {
        type: "SELECT_BOX",
        width: 3,
        name: "year",
        element: {
          label: "Select Year",
          options: yearOptions,
          inputProps: { isFocussed: true },
          inputType: "BORDER_LABEL",
        },
        hideFunction: () => !selectedStage || ["1", "3", "4"].indexOf(selectedStage?.value) === -1
      },
      {
        type: "SELECT_BOX",
        width: 3,
        name: "month",
        element: {
          label: "Select Month",
          options: monthOptions,
          inputProps: { isFocussed: true },
          inputType: "BORDER_LABEL",
        },
        hideFunction: () => !selectedStage || selectedStage?.value !== "3"
      },
      {
        type: "SELECT_BOX",
        width: 3,
        name: "sd_customer_id",
        element: {
          label: "Customer",
          isRequired: true,
          options: customers,
          inputProps: { isFocussed: true },
          inputType: "BORDER_LABEL",
        },
        hideFunction: () => !selectedStage || selectedStage?.value !== "2"
      },
      {
        type: "SELECT_BOX",
        width: 3,
        name: "vehicle_type",
        element: {
          label: "Vehicle Type",
          options: vehicles,
          inputProps: { isFocussed: true },
          inputType: "BORDER_LABEL",
        },
        hideFunction: () => !selectedStage || ["1", "4"].indexOf(selectedStage?.value) === -1
      },
      // {
      //   type: "DATE",
      //   width: 3,
      //   name: "bill_start_date_one",
      //   element: {
      //     label: "Start Date",
      //     placeHolder: "DD-MM-YYYY",
      //     inputType: "BORDER_LABEL",
      //   },
      //   hideFunction: () => !selectedStage || selectedStage?.value !== "3"
      // },
      // {
      //   type: "DATE",
      //   width: 3,
      //   name: "bill_end_date_one",
      //   element: {
      //     label: "End Date",
      //     placeHolder: "DD-MM-YYYY",
      //     minDate: minEndDate,
      //     inputType: "BORDER_LABEL",
      //   },
      //   hideFunction: () => !selectedStage || selectedStage?.value !== "3"
      // },
      {
        type: "BUTTON",
        width: 3,
        name: "Generate",
        element: {
          label: "Generate Report",
          classList: ["has-text-right  mr-2", "smart-action-button"],
          onClick: handleSubmit(onSubmit),
        },
      },
    ];

    return (
      <>
        <div className="columns is-multiline">
          <div className="column is-12 smart-efl-table_main_container is-size-4">
            <p className="has-text-white"> MIS Report</p>
          </div>
          <div className="column is-12">
            <div className="mt-1 sd-efl-input">
              <SdsForm 
                elements={formElements} 
                errors={errors} 
                control={control} 
              />
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div>
      {reportForm()}
      {type === "1" && (
        <HubCapacity 
          year={formValues.year?.value} 
          vehicle_type={formValues.vehicle_type?.value} 
        />
      )}
      {type === "2" && (
        <CustomerLedger 
          sd_customer_id={formValues.sd_customer_id?.value} 
        />
      )}
      {type === "3" && (
        <SalesDetailsTable 
          year={formValues.year?.value} 
          month={formValues.month?.value}
     
        />
      )}
      {type === "4" && (
        <HubVsVichele 
          year={formValues.year?.value} 
          vehicle_type={formValues.vehicle_type?.value} 
        />
      )}
    </div>
  );
};

export default Index;